import { createApp } from 'vue'
import App from '@/App.vue'
import router from '@/routes'
import store from '@/store'
import pinia from '@/stores'
import { createConsent } from '@/vendors/consent'
import { createI18n } from '@/vendors/i18n'
import { useClientStore } from '@/stores/ClientStore'
import { createBranding } from '@/vendors/branding'
import { createMeta, createGoogleTagManager, createMixpanel, createStripe, createSentry, createGoogleMaps, createTamaro, createReCaptcha } from '@/vendors/integrations'
import { createHead } from '@unhead/vue'
import FloatingVue from 'floating-vue'
import FontAwesome from '@/vendors/fontawesome/FontAwesomeIconsLibrary'

const Koalect = createApp(App)
  .use(FontAwesome)
  .use(FloatingVue)
  .use(createHead())
  .use(pinia)
  .use(store)
  .use(createI18n)

const { fetchClient } = useClientStore(pinia)

fetchClient().then(() => {
  Koalect
    .use(createConsent)
    .use(createBranding)
    .use(createSentry, { enabled: true })
    .use(createStripe)
    .use(createTamaro)
    .use(router)
    .use(createGoogleTagManager)
    .use(createMixpanel)
    .use(createMeta)
    .use(createGoogleMaps)
    .use(createReCaptcha)
    .mount('#app')
})